import React from "react";
import { HStack, useColorModeValue } from "@chakra-ui/react";

import { useIsUserLogged } from "modules/authentication/infrastructure/useIsUserLogged";
import { useContextConsumer } from "modules/context/Providers/ContextProvider";

import { ContentArea } from "components/ContentArea";
import { useGetThemeColors } from "ChakraTheme";
import { Logo } from "../Logo";
import { DangerousInnerHtml } from "../../../DangerousInnerHtml";
import { LettersSpacingButton } from "../AccessibilityButtons/LettersSpacingButton";
import { NormalLettersButton } from "../AccessibilityButtons/NormalLettersButton";
import { MediumLettersButton } from "../AccessibilityButtons/MediumLettersButton";
import { BigLettersButton } from "../AccessibilityButtons/BigLettersButton";
import { DarkModeButton } from "../AccessibilityButtons/DarkModeButton";
import { ProfileDropdown } from "../ProfileDropdown";
import { DesktopAuthentication } from "./DesktopAuthentication";

interface IProps {
  logoFileId?: number;
}

const DesktopHeader = ({ logoFileId }: IProps) => {
  const colors = useGetThemeColors();
  const borderColor = useColorModeValue(colors.primary[700], colors.white);
  const isUserLogged = useIsUserLogged();
  const { headHtml } = useContextConsumer();

  return (
    <ContentArea
      h="80px"
      px={5}
      display="flex"
      position="sticky"
      top={0}
      zIndex={100}
      borderBottom={`2px solid ${borderColor}`}
      alignItems="center"
    >
      <HStack
          flex={1}
          spacing={6}
          my={6}>
        <Logo logoFileId={logoFileId} />
        <DangerousInnerHtml html={headHtml} flex={1} />
      </HStack>
      <HStack
        ml="auto"
        d="flex"
        alignItems="center"
        justifyContent="center"
        spacing={1}
      >
        <LettersSpacingButton />
        <NormalLettersButton />
        <MediumLettersButton />
        <BigLettersButton />
        <DarkModeButton />
      </HStack>
      {isUserLogged ? <ProfileDropdown /> : <DesktopAuthentication />}
    </ContentArea>
  );
};

export { DesktopHeader };
